var React = require('react');

function Letter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.979 1.947c.012.08.021.162.021.245v7.616c0 .083-.009.165-.021.245L11.47 6l4.508-4.053zM8.987 7.07c-.535.48-1.44.48-1.974 0L.4 1.125C.728.745 1.224.5 1.778.5h12.444c.554 0 1.05.244 1.376.625l-6.61 5.944zM.021 1.947L4.529 6 .021 10.053A1.62 1.62 0 0 1 0 9.808V2.192c0-.083.009-.165.021-.245zm9.577 5.737l1.225-1.102 4.775 4.293a1.81 1.81 0 0 1-1.376.625H1.778c-.554 0-1.05-.244-1.376-.625l4.775-4.293 1.225 1.102A2.39 2.39 0 0 0 8 8.278c.578 0 1.157-.198 1.598-.594z","fill":"#424242"}));
}

Letter.defaultProps = {"width":"16","height":"12","viewBox":"0 0 16 12"};

module.exports = Letter;

Letter.default = Letter;
